import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class ProjectMappingController {
  constructor($rootScope, $uibModal, $state, $http, toastr) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.projects = [];
    this.qbProjects = [];

    this.loadProjects();
    this.loadQbProjects();

  }


  getProjectName(id) {
    let x = _.find(this.qbProjects, { 'id': id});
    if(x) {
      return x.displayName;
    }
  }

  syncProjectsWithQuickbooks() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/projects/sync", {withCredentials: true}).then(function (success) {
      self.loadProjects();
      self.loadQbProjects();
    });
  }

  updateProjectDetails(id, parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/projects/"+id, obj, {withCredentials: true}).then(function (success) {
      self.loadContracts();
      self.toastr.success("Successfully Paired Project With Quickbooks!", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Could Not Pair Project With Quickbooks.", "ERROR");
    });
  }

  loadProjects() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/admin/projects", {withCredentials: true}).then(function (success) {
      self.projects = success.data;
    });
  }

  loadQbProjects() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/projects", {withCredentials: true}).then(function (success) {
      self.qbProjects = success.data;
    });
  }

}

export default ProjectMappingController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/project-mapping/project-mapping.controller.js